
import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { GeneratedEmailResponse, GetVoucherIsRedeemed, GetVoucherIsRedeemedResponse } from '../api/dtos';

const getData = (response?: SWRResponse<GetVoucherIsRedeemedResponse, GeneratedEmailResponse>) => response?.data?.isRedeemed;

const getError = (response?: SWRResponse<GetVoucherIsRedeemedResponse, GetVoucherIsRedeemedResponse>) => response?.error;

export const useIsVoucherRedeemed = (code?: string, configuration?: SWRConfiguration) => {  
    const request = useMemo(() => {
        
        if(code === null || code === undefined){
            return undefined;
        }
        
        return () => {
            return new GetVoucherIsRedeemed({code: code});
        };
    }, [code])

    return useGet(request, { getData, getError }, configuration);
};

export default useIsVoucherRedeemed;

